import * as React from "react"
import { Link } from "gatsby"

import Home from "../components/home"
import Seo from "../components/seo"

const StaticwebsitePage = () => (
  <Home>
  <div className="masthead-followup row m-0">
	  <div className="col-12 col-md-12 text-center">
      <Seo title="MODERN WEBSITE STATIC WITH JEKYLL BOOOTSTRAP PHYTON NIKOLA" />
    <h1><strong><a href="/staticwebsite">STATIC WEBSITE</a></strong></h1>
   <p>
  Create a Modern website with static site framework and native framework css html.
</p>
<hr/>
<p>
Select your favorite static site generator or full codding with native framework,lets get strated to create or update your website with modern technology. jekyll with ruby on rails , phyton nikola , or native bootstrap .
</p>
</div>
<div className="col-12 col-md-4 p-3 p-md-5 text-center">
<Link title="create website with jekyll ruby on rails" className="p-3 p-md-5 shadow rounded btn btn-outline-danger" to="/jekyll">
<img width="512" alt="create website using modern technology javascript" src="https://mesinkasironline.web.app/img/createwebsitestaticwithjekyll.png"/>
<h3>Jekyll Ruby</h3>
</Link>
    </div>
    <div className="col-12 col-md-4 p-3 p-md-5 text-center">
<Link title="create website with bootstrap" className="p-3 p-md-5 shadow rounded btn btn-outline-primary" to="/bootstrap">
<img className="img-fluid" alt="create website using modern technology javascript" src="https://mesinkasironline.web.app/img/createwebsitewithbootstrap.png"/>
<h3>Bootstrap</h3>
</Link>
    </div>
    <div className="col-12 col-md-4 p-3 p-md-5 text-center">
<Link title="create website with Phyton Nikola" className="p-3 p-md-5 shadow rounded btn btn-outline-warning" to="/nikola">
<img className="img-fluid" width="512" alt="create website using modern technology javascript" src="https://mesinkasironline.web.app/img/createwebsitewithphytonnikola.png"/>
<h3>Phyton Nikola</h3>
</Link>
    </div>
    <div className="col-12 col-md-12 p-3 p-md-5 text-center">
<p>Static site is fast website technology, without database make super fast for accsess website, you can deploy website with jekyll , phyton nikola or native bootstrap for modern website solutions.</p>
    </div>
    <div className="col-12 col-md-12 text-center p-3 p-md-5">
<p>Explore all website design service and online shop</p>
  <Link to="/makewebsite" className="button">Explore all</Link>
  </div>
    </div>
  </Home>
)

export default StaticwebsitePage